import {
    defineStore,
} from 'pinia';

export const useAuth = defineStore('auth', {
    state: () => ({
        loggedInUser: null,
    }),
    actions: {
        setUser(user) {
            this.loggedInUser = user;
        },
        removeUser() {
            this.loggedInUser = null;
        },
    },
    getters: {
        uuid(state) {
            return state.loggedInUser?.uuid;
        },
        isLoggedIn(state) {
            return state.loggedInUser !== null;
        },
    },
});
